import type { FontConfiguration } from '@keyvue/one-ui';

const config: FontConfiguration = {
    fonts: [
        {
            name: 'Nunito Sans',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'PT Sans',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'Bitter',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'Courier New',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'Droid Serif',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'Georgia',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'Helvetica Neue',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'Lato',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'Lucida Sans',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'Montserrat',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'Open Sans',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'Roboto',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'Source Sans Pro',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'Tahoma',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'Times New Roman',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'Trebuchet MS',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'Ubuntu',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        {
            name: 'Verdana',
            sizes: [
                300,
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
    ],
};

export default config;
